import { Link, NavLink, Outlet, ScrollRestoration } from "react-router";

import { useBrand } from "../lib/brand";
import { useMe } from "../lib/queries";

export function Layout() {
  const me = useMe();
  const brand = useBrand();
  const signedIn = Boolean(me.data);

  return (
    <>
      <a className="skip-link" href="#contenu">
        Aller au contenu
      </a>
      <header className="site-header">
        <div className="page site-header__inner">
          <Link to={signedIn ? "/tableau-de-bord" : "/"} className="brand">
            {brand.logoUrl ? (
              // The name follows, so the logo itself is decorative.
              <img className="brand__logo" src={brand.logoUrl} alt="" />
            ) : (
              <span className="brand__mark" aria-hidden="true">
                <span />
                <span />
                <span />
              </span>
            )}
            <span className="brand__name">{brand.name}</span>
            {brand.productName !== brand.name && (
              // The space keeps the two names apart for screen readers.
              <>
                {" "}
                <span className="brand__product">{brand.productName}</span>
              </>
            )}
          </Link>
          <nav className="site-nav" aria-label="Navigation principale">
            {signedIn ? (
              <>
                {me.data?.approved && <NavLink to="/tableau-de-bord">Mes entreprises</NavLink>}
                {me.data?.is_admin && <NavLink to="/admin">Administration</NavLink>}
                <NavLink to="/compte">Compte</NavLink>
              </>
            ) : (
              me.isSuccess && (
                <Link to="/connexion" className="button button--quiet button--small">
                  Se connecter
                </Link>
              )
            )}
          </nav>
        </div>
      </header>
      <main id="contenu" tabIndex={-1}>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="page site-footer__inner">
          <p>
            {brand.footerText && <>{brand.footerText} </>}
            Service indépendant, non affilié à l'administration. Données publiques : BODACC (DILA) et
            répertoire Sirene (INSEE).
          </p>
          <nav aria-label="Pied de page">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <a href="/#questions">Questions fréquentes</a>
          </nav>
        </div>
      </footer>
      <ScrollRestoration />
    </>
  );
}
